module.exports = __webpack_public_path__ + "img/ellipse27.c15cff95.png";